import React, { useState } from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import colours from '../../tokens/colours';
import fonts from '../../tokens/fonts';
import fontWeights from '../../tokens/fontWeights';
import fontSizes from '../../tokens/fontSizes';
import baseStyles from '../../atoms/styles/baseStyles';
import CaretIcon from '../../atoms/icons/CaretIcon';
const getStyles = createUseStyles({
    ...baseStyles,
    root: {
        cursor: 'pointer',
        backgroundColor: colours.inputBackground,
        borderRadius: 4,
        border: `1px solid ${colours.inputBackground}`,
        padding: '0 1.5rem 0.7rem 1.5rem',
        transition: 'all 0.2s linear',
        width: '100%',
        minHeight: '5.6rem',
        boxSizing: 'border-box',
        position: 'relative',
        paddingRight: 56,
        color: colours.primary,
    },
    isError: {
        borderColor: '#E0032A',
        backgroundColor: 'rgba(224,3,42,0.051)',
    },
    isOpen: {
        borderColor: colours.primary,
    },
    label: {
        display: 'block',
        position: 'relative',
        color: colours.sexternary,
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        fontSize: '1.4rem',
        lineHeight: '2.4rem',
        height: '2.4rem',
        top: '1.7rem',
        transition: ['all', '0.2s', 'linear'],
    },
    labelDisabled: {
        color: colours.quinternary,
    },
    labelActive: {
        fontSize: '1.2rem',
        lineHeight: '1.6rem',
        height: '1.6rem',
        top: '0.6rem',
    },
    value: {
        display: 'block',
        fontFamily: fonts.roboto,
        fontWeight: fontWeights.Regular,
        color: colours.primary,
        marginTop: 8,
        fontSize: fontSizes.Regular,
        lineHeight: '2rem',
    },
    icon: {
        width: 'auto',
        height: '2.2rem',
        position: 'absolute',
        top: 18,
        right: 8,
        transition: ['transform', '0.2s', 'linear'],
    },
    iconOpen: {
        transform: 'rotate(180deg)',
    },
});
const ToggleButton = ({ onClick, onBlur, isOpen, value, children, isError = false, disabled = false, }) => {
    const styles = getStyles();
    const [isHover, setIsHover] = useState(false);
    const getIconFill = () => {
        if (disabled) {
            return colours.quinternary;
        }
        if (isHover) {
            return colours.primary;
        }
        return '#505271';
    };
    return (React.createElement("div", { role: "button", tabIndex: 0, className: classNames(styles.root, { [styles.isError]: isError && !isOpen }, { [styles.isOpen]: isOpen }), onClick: disabled ? undefined : onClick, onMouseOver: () => setIsHover(true), onFocus: () => setIsHover(true), onMouseOut: () => setIsHover(false), onBlur: onBlur },
        React.createElement("span", { className: classNames(styles.label, { [styles.labelDisabled]: disabled }, { [styles.labelActive]: !!value && !isOpen }) }, children),
        value && !isOpen && React.createElement("span", { className: styles.value }, value),
        React.createElement(CaretIcon, { className: classNames(styles.icon, { [styles.iconOpen]: isOpen }), fill: getIconFill() })));
};
export default ToggleButton;
//# sourceMappingURL=ToggleButton.js.map